import { invalidateBrandSpaceProgramOptions } from '@/hooks/queries/use-brand-space-program-options-query';
import api from '@/libs/axiosInstance';
import type { Program } from '@fluenceur/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type UpdateProgramStatusVariables = { programId: string; isActive: boolean };

/**
 * Turns a programme on or off (`PUT /dashboard/programs/:id/status`), the path
 * every activation goes through and the one the plan's programme limit guards.
 * Refreshes every programme list and the programme itself once it lands.
 */
export function useUpdateProgramStatusAction() {
  const queryClient = useQueryClient();

  return useMutation<Program, unknown, UpdateProgramStatusVariables>({
    mutationFn: async ({ programId, isActive }) => {
      const response = await api.put<Program>(`/dashboard/programs/${programId}/status`, {
        isActive,
      });
      return response.data;
    },
    onSuccess: (_, { programId }) => {
      void queryClient.invalidateQueries({ queryKey: ['programs'] });
      void queryClient.invalidateQueries({ queryKey: ['program', programId] });
      void invalidateBrandSpaceProgramOptions(queryClient);
    },
  });
}
